// Public page reached from the email link. Sets a new password.
// URL: /reset-password?token=…
import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import './AuthPages.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!token) { setError('This reset link is missing its token. Request a new one.'); return; }
    if (pw1.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (pw1 !== pw2)   { setError('Both passwords must match.'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: pw1 }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Could not reset password');
      setDone(true);
      setTimeout(() => navigate('/login'), 2200);
    } catch (e) { setError(e.message); }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">VP</div>
        <h1 className="auth-title">Choose a new password</h1>
        <p className="auth-sub">For your Vyapar Pro account.</p>

        {done ? (
          <div className="auth-note auth-note--success">
            <div className="auth-note-strong">Password updated.</div>
            <div style={{ marginTop: 6 }}>Redirecting you to sign in…</div>
          </div>
        ) : (
          <form onSubmit={submit} noValidate>
            <div className="auth-field">
              <label className="auth-label">New password</label>
              <div className="auth-pw-wrap">
                <input
                  className="auth-input"
                  type={showPw ? 'text' : 'password'}
                  value={pw1}
                  onChange={e => setPw1(e.target.value)}
                  placeholder="At least 6 characters"
                  style={{ paddingRight: 52 }}
                  autoFocus
                />
                <button type="button" className="auth-pw-toggle" onClick={() => setShowPw(s => !s)}>
                  {showPw ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <div className="auth-field">
              <label className="auth-label">Confirm new password</label>
              <input
                className="auth-input"
                type={showPw ? 'text' : 'password'}
                value={pw2}
                onChange={e => setPw2(e.target.value)}
                placeholder="Type it again"
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="auth-btn" disabled={loading || !token}>
              {loading ? (<><span className="auth-spinner" aria-hidden="true" /><span>Updating…</span></>) : <span>Update password</span>}
            </button>

            <div className="auth-foot"><Link to="/login">← Back to sign in</Link></div>
          </form>
        )}
      </div>
    </div>
  );
}
